export class JobReportViewModel {
  constructor(
    public tenantUniqueId: string,
    public mediaId: number,
    public dateTime: string,
    public deliveryStatus: string,
    public downloadUrl: string,
  ) {}
}
